export default __webpack_public_path__ + "static/media/close-button.296c3114.svg";